import { JBaseApi } from '../base';
import {
    ApiWrapper,
    JLandLog,
    JLandMap,
    JLandMapCreation,
    JLandMapList,
    JLandMapLittle,
    JLandMapView,
    JLandStat,
    MaybeWithToken,
    PagingResults,
} from '../../types';
import { OF } from '../../util/network';

export class JLandApi extends JBaseApi {
    public getLogs({
        dateEnd,
        idLogMax,
    }: {
        dateEnd?: string;
        idLogMax?: number;
    }): Promise<ApiWrapper<Array<JLandLog>>> {
        return this.network.post({
            o: 'jLand',
            f: 'adminLogs',
            dateEnd,
            idLogMax,
        } as OF);
    }

    public getStats({
        map,
        dateStart,
        dateEnd,
    }: {
        map: string;
        dateStart?: string;
        dateEnd?: string;
    }): Promise<ApiWrapper<Array<JLandStat>>> {
        return this.network.post({
            o: 'jLand',
            f: 'adminStats',
            map,
            dateStart,
            dateEnd,
        } as OF);
    }

    public getAllMapsAsAdmin(format = 'raw-list,licenses'): Promise<ApiWrapper<PagingResults<JLandMap>>> {
        return this.network.post({
            o: 'objectListJLand',
            f: 'jLandList',
            format: format,
        } as OF);
    }

    public createMap<T extends JLandMapLittle | JLandMapList | JLandMapView = JLandMapList>(
        map: MaybeWithToken<JLandMapCreation>,
        format = 'raw-list',
    ): Promise<ApiWrapper<T[]>> {
        return this.network.maybePostToken({
            ...map,
            o: 'article',
            f: 'create',
            format: format,
            type: 'jlandmap',
        } as OF);
    }
}
